import Component from '../abstracts/Component';
import GalleryManager from '../utils/GalleryManager';
import FiltersComponent from '../components/FiltersComponent';

export default class ShortcutComponent extends Component {

  get SELECTORS() {
    return {
      arrowRight: '[data-arrow-right]',
      arrowLeft: '[data-arrow-left]',
      scroller: '[data-simplebar-wrapper]',
      itemsContainer: '[data-shortcut-items]',
      item: '[data-shortcut-item]',
      input: '[type="radio"]',
      firstShortcut: '#shortcut_0',
      breadcrumbsWrapper: '.breadcrumbs__wrapper',
      chevronShortcutPage: '[data-chevron-shortcut-page]'
    };
  }

  get QUERY_PARAMS() {
    return {
      base: '?save=false&q=:topRated',
      end: ':sortBy:topRated&size=-1', //page size -1 enables the page to hide the infinite page button
    }
  }

  get COMPONENTNAME() {
    return 'ShortcutComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);

    this.firstShortcut = document.querySelector(this.SELECTORS.firstShortcut);
    this.FiltersComponent = new FiltersComponent(htmlEl);

    this.breadcrumbsWrapper = document.querySelector(this.SELECTORS.breadcrumbsWrapper);
    this.chevronShortcutPage = document.querySelector(this.SELECTORS.chevronShortcutPage);

    this.urlParams = new URLSearchParams(window.location.search);
  }

  render() {
    super.render();
    this.bindEvents();
    this.galleryManager = new GalleryManager(
      this.SELECTORS,
      this.$component,
      this.moduleLoader
    );
    // window.addEventListener('pageshow', () => this.restoreShortcutFromUrl());
  }


  bindEvents() {
    if (this.firstShortcut != null && this.firstShortcut != 'undefined') {
      this.firstShortcut.addEventListener('click', (e) => {
        if (!e.currentTarget.classList.contains('selected')) {
          if (e.currentTarget.dataset.isLink === "true") {
            this.navigateToUrl(e.currentTarget.dataset.href);
          } else {
            this.FiltersComponent.filterQuery(false, '', true);
            this.hideBreadcrumbs();
            this.removeShortcutCodeFromUrl();
          }
        }
      });
    }

    document.querySelectorAll(this.SELECTORS.item).forEach((item) => {
      const isFirstItem = item.id === 'shortcut_0';

      if (!this.urlParams.get('code')) {
        if (window.location.pathname === item.dataset.href) {
          item.classList.add('selected');
          item.querySelector('input').setAttribute('checked', true);
        } else if (!isFirstItem) {
          item.classList.remove('selected');
          item.querySelector('input').removeAttribute('checked');
        }
      }

      item.addEventListener('click', () => {

        if (!item.classList.contains('selected')) {

          item.classList.toggle('selected');
          item.querySelector('input').setAttribute('checked', true);
          document.querySelectorAll(this.SELECTORS.item).forEach((otherEl) => {
            if (otherEl.id !== item.id) {
              otherEl.classList.remove('selected');
              otherEl.querySelector('input').removeAttribute('checked');
            }
          });

          if (item.dataset.isLink == 'false' && (item.dataset.products || isFirstItem)) {
            // reset filters
            this.FiltersComponent.resetFilters();
            this.FiltersComponent.filterQuery(false);
            if (!isFirstItem) {
              this.showBreadcrumbs(item.dataset.shortcutTitle);
              this.addShortcutCodeToUrl(item.dataset.shortcutCode);
            } else {
              this.removeShortcutCodeFromUrl();
            }
          }

          if (item.dataset.isLink == 'true' && item.dataset.href) {
            this.navigateToUrl(item.dataset.href);
          }
        } else if (!isFirstItem) {
          item.classList.toggle('selected');
          this.hideBreadcrumbs();
          item.querySelector('input').removeAttribute('checked');
          if (this.firstShortcut) {
            if (this.firstShortcut.dataset.isLink == "false") {
              this.firstShortcut.classList.add('selected');
              this.firstShortcut.querySelector('input').setAttribute('checked', true);
            }
          }
          this.FiltersComponent.filterQuery(false);
          this.removeShortcutCodeFromUrl();
        }
      });
    });

    if (this.breadcrumbsWrapper) {
      this.breadcrumbsWrapper.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link && !link.classList.contains('shortcut-page')) {
          e.preventDefault();
          if (this.firstShortcut) {
            this.firstShortcut.click();
          }
        } else if (link && link.classList.contains('shortcut-page')) {
          if (window.matchMedia('(max-width: 1023px)').matches) {
            e.preventDefault();
            if (this.firstShortcut) {
              this.firstShortcut.click();
            }
          }
        }
      });
    }
  }

  showBreadcrumbs(title) {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      this.breadcrumbsWrapper.querySelector('a.shortcut-page').innerHTML = title;
      this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
        el.style.display = 'inline-block';
      });
    } else {
      const breadcrumbLinks = this.breadcrumbsWrapper.querySelectorAll('a:not(.shortcut-page)');
      const previousBreadcrumb = breadcrumbLinks[breadcrumbLinks.length - 1];
      
      breadcrumbLinks.forEach((link) => {
        link.style.display = 'none';
      });
      
      this.breadcrumbsWrapper.querySelectorAll('.breadcrumbs__separator, .breadcrumbs__chevron, span:not(.shortcut-page)').forEach((separator) => {
        separator.style.display = 'none';
      });
      
      if (previousBreadcrumb) {
        this.breadcrumbsWrapper.querySelector('a.shortcut-page').innerHTML = previousBreadcrumb.innerHTML;
      } else {
        this.breadcrumbsWrapper.querySelector('a.shortcut-page').innerHTML = title;
      }
      
      this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
        el.style.display = 'inline-block';
      });

      if (this.chevronShortcutPage) {
        this.chevronShortcutPage.classList.add('--back');
        this.breadcrumbsWrapper.classList.add('mobile-current-shortcut');
      }
    }
  }

  hideBreadcrumbs() {
    this.breadcrumbsWrapper.querySelectorAll('a:not(.shortcut-page)').forEach((el) => {
      el.style.display = '';
    });
    
    this.breadcrumbsWrapper.querySelectorAll('.breadcrumbs__separator, .breadcrumbs__chevron, span:not(.shortcut-page)').forEach((separator) => {
      separator.style.display = '';
    });
    
    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
      el.style.display = 'none';
    });

    if (this.chevronShortcutPage) {
      this.breadcrumbsWrapper.classList.remove('mobile-current-shortcut');
    }
  }

  addShortcutCodeToUrl(shortcutCode) {
    if (!shortcutCode) return;

    const storageKey = `shortcut_${window.location.pathname}`;
    sessionStorage.setItem(storageKey, shortcutCode);

    this.urlParams.set('code', shortcutCode);
    const newUrl = window.location.pathname + '?' + this.urlParams.toString();
    window.history.replaceState(null, null, newUrl);
  }

  removeShortcutCodeFromUrl() {
    const storageKey = `shortcut_${window.location.pathname}`;
    sessionStorage.removeItem(storageKey);

    this.urlParams.delete('code');
    const newUrl = window.location.pathname + (this.urlParams.toString() ? '?' + this.urlParams.toString() : '');
    window.history.replaceState(null, null, newUrl);
  }

  // New method to handle navigation for buttons
  navigateToUrl(url) {
    if (url) {
      window.location.href = url;
    }
  }

  restoreShortcutFromUrl() {
    let shortcutCode = this.urlParams.get('code') ||
                       sessionStorage.getItem(`shortcut_${window.location.pathname}`);

    if (!shortcutCode) return;

    const shortcutItem = document.querySelector(`[data-shortcut-code="${shortcutCode}"]`);
    if (!shortcutItem || shortcutItem.dataset.isLink === 'true') return;

    document.querySelectorAll('.shortcut__item').forEach(item => {
      item.classList.remove('selected');
      const input = item.querySelector('input');
      if (input) {
        input.removeAttribute('checked');
        input.checked = false;
      }
    });

    shortcutItem.classList.add('selected');
    const input = shortcutItem.querySelector('input');
    if (input) {
      input.setAttribute('checked', true);
      input.checked = true;
    }

    if (shortcutItem.id !== 'shortcut_0') {
      this.showBreadcrumbs(shortcutItem.dataset.shortcutTitle);
    } else {
      this.hideBreadcrumbs();
    }

    const applyFilters = () => {
      if (this.FiltersComponent) {
        this.FiltersComponent.resetFilters();
        this.FiltersComponent.filterQuery(false);
      }
    };

    applyFilters();

  }

}
